module.exports = __webpack_public_path__ + "static/img/018.7e57161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/018.png
// module id = sirO
// module chunks = 1